<template>
	<section class="full">
		<van-nav-bar title="充值" left-arrow @click-left="skipUser" class="top_bar" />	
		<section class="full_box">
			<div class="full_num">
				<h4>请选择展业币套餐</h4>
				<div class="list">
					<div class="item" @click="chooseNum(i)" :class="{active: activeIndex==i}" v-for="(item,i) in numList" :key="item.id">
						<span>{{item.virtualAmount}}展业币</span>
						<span class="bonus" v-if="item.virtualAmount-item.price/100">双11送{{item.virtualAmount-item.price/100}}币</span>
						<!-- <img src="../../../assets/img/chongzhi_bg.png" v-if="activeIndex==i" > -->
					</div>
				</div>
			</div>
			<div class="zhifu">
				<p class="tit">请选择支付方式</p>
				<van-cell :title="item.name" :icon="item.icon" v-for="item in typeList" :key="item.id">
					<template #right-icon>
						<div v-if="payTypeId==item.id">
							<img src="../../../assets/img/check_a.png" class="check" @click="checkFn(item.id)">
						</div>
						<div v-else>
							<img src="../../../assets/img/check.png" class="check" @click="checkFn(item.id)">
						</div>
					</template>
				</van-cell>
				<div class="ticket" v-if="accountType!=1">
					<p class="tits">请选择优惠券</p>
					<div class="ticket_info">
						<div class="left">
							<img src="../../../assets/img/quan.png" alt="">
							优惠券
							<i v-if="ticketCount==0">0张可用</i>
						</div>
						<div class="right" @click="getTicket" v-if="!tickeId">
							<span v-if="ticketCount>0">{{ticketCount}}张可用</span>
							<i v-else>去领券</i>
							<van-icon name="arrow" />
						</div>
						<div class="right" v-else @click="selectTicket">
							<div class="ticket_name">
								<p class="name">{{tickeTitle}}</p>
								<p class="suitable" v-if="isSuitable">{{tickeTxt}}</p>
								<p class="inconformity" v-else>{{tickeTxt}}</p>
							</div>
							<van-icon name="arrow" />
						</div>
					</div>
				</div>
				<van-collapse v-model="activeNames">
					<van-collapse-item title="购买注意事项" name="1">
						<p>1. 展业币仅限在本平台购买商品和服务时作支付之用，不做他用，不得转让、赠予，也无法提现。</p>
					</van-collapse-item>
				</van-collapse>
			</div>
			<div class="bottom_btn">
				<div class="left">
					<div>
						<div>
							<p>支付金额</p>
							<span>¥</span>
							<i>{{price}}</i>
						</div>
						<!-- <p class="youhui" v-if="isSuitable">已优惠：¥{{discounts}}</p> -->
						<p class="youhui" v-if="this.discounts">已优惠：¥{{this.discounts}}</p>
					</div>			
				</div>
				<div class="right">
					<van-button type="danger" class="danger-button" @click="payFn">立即购买</van-button>
				</div>
			</div>
		</section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import buyServer from "api/buy";
import ticketServer from "api/ticket";
import { Notify,Dialog } from 'vant';



export default {
	components: {
		Nav,
	},
	data() {
		return {
			numInit: 100,
			numList: [],
			price: '',
			skuId: '',
			activeIndex:0,
			activeNames: [0],
			isCheck: 1,
			clientType: this.$store.state.clientType,  //客户端类型 1 ios 2安卓 3h5	
			pid: '',
			params: {
				orderId: '',
				amount: '',
			},
			payTypeId: '',
			typeList: [],
			//优惠券
			isTicketNum: 0,
			tickeId: '',
			tickeTxt: '',
			tickeTitle: '',
			isSuitable: '',
			ticketCount: '',
			discounts: 0,
			minAmount: '',
			accountType: 3,
		}
	},
	created() {
		this.params.orderId = this.$route.params.id
		this.tickeId = this.$route.query.tickeid||''
		this.accountType = localStorage.getItem("accountType")|| 3
		this.activeIndex = this.$route.query.index||0
		this.getNumList()
		this.getPayList()
		this.getTicketCount()

	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getTicketCount() {
			let params = {
				pageNum: 1,
				pageSize: 100,
				history: 0,
			}
			ticketServer.SearchMyTicket(params).then((res) => {
				this.ticketCount = res.data.total
			})
		},
		getTicketInfo() {
			ticketServer.SearchTicketInfo({userCouponId: this.tickeId}).then((res) => {
				this.minAmount = res.data.minAmount/100
				if(this.price>=this.minAmount) {
					this.tickeTxt = `充值满${this.minAmount}元可用，已符合条件`
					this.isSuitable = 1
					this.getMoney()
				}else {
					this.tickeTxt = `充值满${this.minAmount}元可用，不符合条件`
					this.isSuitable = 0
				}
				if(res.data.couponType == 1) {
					this.tickeTitle = `${res.data.couponName}-抵扣券 ${res.data.deduction/100}元`
				}else if(res.data.couponType == 2) {
					this.tickeTitle = `${res.data.couponName}-折扣券 ${(res.data.couponDenomination*10).toFixed(1)}折`
				}
			})
		},
		getMoney() {
			ticketServer.Searchprice({amount: this.price*100, userCouponId: this.tickeId}).then((res) => {
				// this.discounts = (this.price*100-res.data)/100
				this.discounts = (this.numList[this.activeIndex].virtualAmount*100-res.data)/100
				this.price = res.data/100
			})
			
		},
		getPayList () {
			buyServer.SearchPayType({clientType: this.clientType}).then((res) => {
				this.typeList = res.data
				this.payTypeId = this.typeList[0].id
			})
		},
		getNumList() {
			buyServer.SearchPayList().then((res) => {
				this.numList = res.data
				this.price = this.numList[this.activeIndex].price/this.numInit
				this.skuId = this.numList[this.activeIndex].id
				this.pid = this.numList[this.activeIndex].appleGoodsId||0
				if(this.tickeId) {
					this.getTicketInfo()
				}else {

				}
			})
		},
		chooseNum(i) {
			this.activeIndex = i
			this.price = this.numList[i].price/100
			this.skuId = this.numList[i].id
			this.pid = this.numList[i].appleGoodsId||0
			this.discounts = this.numList[i].virtualAmount - this.numList[i].price/100
			if(this.tickeId) {
				if(this.price>=this.minAmount) {
					this.tickeTxt = `支付满${this.minAmount}元可用，已符合条件`
					this.isSuitable = 1
					this.getMoney()
				}else {
					this.tickeTxt = `支付满${this.minAmount}元可用，不符合条件`
					this.isSuitable = 0
				}
			}

		},
		checkFn(id) {
			this.payTypeId = id
		},
		getTicket() {
			if(this.ticketCount>0) {
				this.$router.push({name: 'ticket-select', query:{index: this.activeIndex}})
			}else {
				this.$router.push({name: 'ticket-get'})
			}
		}, 
		selectTicket() {
			this.$router.push({name: 'ticket-select', query:{id: this.tickeId, index: this.activeIndex}})
		},
		skipUser() {
			this.$router.push({name: 'user'})
		},
		requestPay() {
			if(!this.isCheck) return Notify({ type: 'danger', message: '请选择支付方式' })
				buyServer.SearchPayID({skuId: this.skuId,count: 1, userCouponId: this.tickeId}).then((res) => {
					localStorage.setItem("status", 1)
					if(this.payTypeId==3) {  //3是支付宝sdk
						this.$router.push({name: 'alipay', params:{id:res.data.orderId,amount:res.data.amount,type:this.payTypeId, pid: this.pid||0, sid: this.skuId }})
					}else { //是1:ipa以及2:h5 支付
						this.$router.push({name: 'payView', params:{id:res.data.orderId,amount:res.data.amount,type:this.payTypeId, pid: this.pid||0, sid: this.skuId }})

					}
					return
				})
		},
		payFn() {
			if(this.tickeId) {
				if(!this.isSuitable) {
					Dialog.alert({
						title: '充值',
						message: '当前选择的优惠券不符合使用条件，请更换优惠券或修改充值金额',
					}).then(() => {
					// on close
					});
				}else {
					this.requestPay()
				}
			}else {
				this.requestPay()
			}
			
		},
	}
}
</script>

<style lang="scss">
	.full {
		padding-top: 46px;
		color: #2B2F3A;
		.full_num {
			padding: 19px 21px;
			padding-bottom: 0;
			padding-right: 0;
			background: #fff;
			margin-bottom: 16px;
			h4 {
				font-size: 15px;
				padding-bottom: 18px;
			}
			p {
				font-size: 16px;
				padding-top: 7px;
				padding-bottom: 20px;

			}
			.list {
				display: flex;
				flex-wrap: wrap;
				.item {
					position: relative;
					width: 102px;
					height: 71px;
					font-size: 16px;
					line-height: 71px;
					border-radius: 4px;
					background: #fff;
					text-align: center;
					margin-bottom: 16px;
					margin-right: 13px;
					border: 1px solid #7E92E2;
					color: #3A5EEC;
					span {
						position: relative;
						z-index: 2;
					}
					
					span.bonus {
						position: absolute;
						top: 0px;
						width: 100%;
						left: 0;
						font-size: 10px;
						line-height: 24px;
					}					
					img {
						position: absolute;
						bottom: 0;
						right: 0;
						width: 83px;
						z-index: 1;
					}
				}
				.active {
					background: #3A5EEC;
					color: #fff;
					font-weight: bold;

				}
			}
		}
		.zhifu {
			background: #fff;
			.tit {
				color: #7D8290;
				font-size: 14px;
				padding: 13px 19px;
			}
			.van-cell {
				// height: 50px;
				align-items: center;
				padding: 10px 21px;
				display: flex;
				align-items: center;
			}
			.van-cell__title {
				font-size: 15px;
				color: #2B2F3A;
			}
			.van-icon__image, .check {
				width: 22px;
				height: 22px;
			}
			.van-cell__left-icon, .van-cell__right-icon {
				height: 22px;
				width: 22px;
			}
			.van-collapse {
				border-top: 1Px solid #F6F6F6;
				.van-cell__right-icon {
					color: #7D8290;
				}
				span {
					color: #7D8290;
					font-size: 14px;

				}
				.van-icon {
					color: #CCCED4;
					font-size: 18px;
				}
			}
			.van-collapse-item__title--expanded::after, .van-cell::after {
				display: none;
			}
			.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
				border: 0;
				// border-top: 1Px solid #f6f6f6;
			}
			.van-collapse-item__content {
				color: #7D8290;
				font-size: 14px;
				p {
					padding-bottom: 8px;
				}
			}
			
		}
		.ticket {
			border-top: 1Px solid #f6f6f6;
			margin-top: 6px;
			padding: 16px 19px;
			padding-bottom: 0;
			.tits {
				color: #7D8290;
				font-size: 14px;
			}
			.ticket_info {
				display: flex;
				justify-content: space-between;
				.left {
					display: flex;
					align-items: center;
					font-size: 15px;
					color: #2B2F3A;
					img {
						width: 22px;
						margin-right: 7px;
					}
					i {
						font-style: normal;
						padding-left: 6px;
						color: #A2A6AE;
						font-size: 12px;
					}
				}
				.right {
					display: flex;
					align-items: center;
					padding: 19px 0;
					i {
						font-style: normal;
						color: #3A5EEC;
						font-size: 14px;
					}
					span {
						color: #7D8290;
						font-size: 14px;
						padding-right: 2px;
					}
					.van-icon {
						font-size: 16px;
						color: #CCCED4;
					}
					.ticket_name {
						padding-right: 2px;
						.name {
							color: #575F72;
							font-size: 13px;
						}
						.suitable {
							color: #A2A6AE;
							font-size: 12px;
						}
						.inconformity {
							color: #FC0E2D;
							font-size: 12px;
						}
					}

				}
			}
		}
		.bottom_btn {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			display: flex;
			align-items: center;
			height: 56px;
			.left {
				width: 52%;
				padding-left: 21px;
				background: #FFF;
				height: 56px;
				display: flex;
				align-items: center;
				div div {
					display: flex;
					align-items: center;
					p {
						font-size: 16px;
					}
					span {
						font-size: 15px;
						font-weight: bold; 
						padding-left: 6px;
						
					}
				}
				.youhui {
					color: #FC0E2D;
					font-size: 12px;
				}
				
				i {
					font-size: 20px;
					font-weight: bold;
					font-style: normal;
				}
			}
			.right {
				width: 48%;
				.danger-button {
					width: 100%;
					height: 56px;
					font-size: 17px;
					font-weight: bold;
					border: 0;
				}
			}


		}
		.recharge_success, .recharge_fail {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			text-align: center;
			width: 100%;
			img {
				width: 104px;
			}
			p {
				color: #2B2F3A;
				font-size: 20px;
				font-weight: bold;
				padding-top: 15px;
			}
			.van-button--danger {
				margin-top: 68px;
				width: 217px;
				height: 46px;
				font-size: 17px;
				font-weight: bold;
				.van-button__text {
					color: #fff;
					padding-top: 0;
				}
				
			}

		}
		.recharge_loading {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			text-align: center;
			width: 100%;
			img {
				width: 120px;
			}
			p {
				color: #575E72;
				font-size: 16px;
				padding-top: 36px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/full/Full.vue